import { Component, OnInit, OnDestroy, Output, EventEmitter, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { filter } from 'rxjs/internal/operators/filter';

import { Origin } from '@classes/origin/origin';
import { UiService } from '@services/ui.service';
import { AuthService } from '@services/auth.service';
import { UserService } from '@services/user.service';
import { SimulationService } from '@services/simulation.service';

@Component({
    selector: 'app-main-header',
    templateUrl: './main-header.component.html',
    styleUrls: ['./main-header.component.scss']
})
export class MainHeaderComponent implements OnInit, OnChanges, OnDestroy {
    @Input() isAuth: boolean;
    @Output() sidenavToggle = new EventEmitter<void>();

    private userParamsSub: Subscription;
    private selectedSimuSub: Subscription;

    pageTitle: string;
    origin: Origin;
    selSimuName: string;

    constructor(
        private uiSrv: UiService,
        private authSrv: AuthService,
        private userSrv: UserService,
        private simuSrv: SimulationService,
        private router: Router,
        private activatedRoute: ActivatedRoute
    ) { }

    ngOnInit() {
        this.getUserParameters();
        this.initSubscriptions();
        this.initTitleSub();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes.isAuth.currentValue !== changes.isAuth.previousValue) {
            this.getUserParameters();
        }
    }

    onToggleSidenav(): void {
        this.sidenavToggle.emit();
    }

    onLogout(): void {
        this.authSrv.logout();
    }

    private initSubscriptions(): void {
        this.userParamsSub = this.userSrv.userParametersSubject
        .subscribe(parameters => {
            this.origin = parameters ? parameters.origin : null;
        });

        this.selectedSimuSub = this.simuSrv.selectedSimulationChanged
        .subscribe(simulation => {
            this.selSimuName = simulation ? simulation.userText.shortLabel : null;
        });
    }

    private getUserParameters(): void {
        if(this.isAuth) {
            this.userSrv.getParameters().subscribe();
        } else {
            this.origin = null;
        }
    }

    private initTitleSub(): void {
        this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd),
            map(() => this.activatedRoute),
            map((route) => {
               while (route.firstChild) {
                 route = route.firstChild;
               }
               return route;
            }),
            filter((route) => route.outlet === 'primary'),
            mergeMap((route) => route.data)
        ).subscribe((event) => {
                this.pageTitle = event['title'] + '.shortLabel';
            this.uiSrv.changeTitle(this.pageTitle);
        });
    }

    ngOnDestroy(): void {
        if(this.userParamsSub) {
            this.userParamsSub.unsubscribe();
        }
        if(this.selectedSimuSub) {
            this.selectedSimuSub.unsubscribe();
        }
    }
}
